import { NextRouter } from 'next/router';

export const NAVBAR_ITEM_MAPPINGS = {
  'news-and-analysis': 'newsAndAnalysis',
  '/': 'home',
  guides: 'guidesAndReviews',
  listings: 'search',
  favorites: 'favorites',
};

export function getHighlightedNavbarItem(url = ''): string | undefined {
  if (url === '/') return NAVBAR_ITEM_MAPPINGS['/'];

  return Object.entries(NAVBAR_ITEM_MAPPINGS).find(
    ([path]) => path !== '/' && url.includes(path)
  )?.[1];
}

export function removeVin(str: string | undefined): string | undefined {
  if (str === undefined) return str;

  const [baseUrl, hash] = str.split('#');
  const [path, query] = baseUrl.split('?');

  // Handle query parameters in base URL
  const filteredQuery = query
    ? query
        .split('&')
        .filter((param) => !param.startsWith('vin='))
        .join('&')
    : '';

  // Handle hash parameters
  const filteredHash = hash
    ? hash
        .split('&')
        .filter((param) => !param.startsWith('vin='))
        .join('&')
    : '';

  // Reconstruct the URL
  let result = path;
  if (filteredQuery) result += `?${filteredQuery}`;
  if (filteredHash) result += `#${filteredHash}`;

  return result;
}

export function handleDirectToVdpNavigation(router: NextRouter, vdpUrl: string): void {
  router.push(vdpUrl.split('#')[0]);
}

export function handleSrpNavigation(router: NextRouter): void {
  const { asPath } = router;
  const trimmedPath = removeVin(asPath) as string;
  router.push(trimmedPath);
}
